import { IAuthPayload, ITokenData } from 'interfaces/IAuth';
import { api } from './api';

const { REACT_APP_COMPANY } = process.env;

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    auth: build.mutation<
      ITokenData,
      { authData: IAuthPayload; turnstileToken?: string; productType?: string }
    >({
      query: ({ authData, turnstileToken }) => ({
        url: `token`,
        method: 'POST',
        body: authData,
        params: { productType: REACT_APP_COMPANY },
        headers: turnstileToken
          ? { 'Turnstile-Token': turnstileToken }
          : undefined,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useAuthMutation } = authApi;

export const {
  endpoints: { auth },
} = authApi;
